import { cx } from '@emotion/css';
import type { FC } from 'react';

import { AspectRatio, BackgroundColor } from '../../../constants';
import { useIsMobile } from '../../../hooks';
import { Icon } from '../../Icon';
import { Anchor } from '../../Primitives';
import {
  arrowIconCss,
  blackIconCss,
  blackThemeCss,
  bodyCss,
  cardContainerClickableCss,
  cardContainerCss,
  cardDropShadowCss,
  contentContainerCss,
  image11Css,
  image32Css,
  image169Css,
  mediaContainerCss,
  mediaElementCss,
  titleContainerCss,
  titleCss,
} from './styles';
import type { CardStackCardProps } from './types';

export const CardStackCard: FC<CardStackCardProps> = ({
  aspectRatio = AspectRatio['1:1'],
  body,
  media,
  theme,
  title,
  url,
}) => {
  const isClickable = !!url;
  const CardWrapper = isClickable ? Anchor : 'div';
  const isMobile = useIsMobile();

  return (
    <CardWrapper
      data-testid={'sdsm-card-stack-card'}
      className={cx(cardContainerCss, {
        [cardContainerClickableCss]: isClickable,
        [cardDropShadowCss]: theme === BackgroundColor.White && !isMobile,
        [blackThemeCss]: theme === BackgroundColor.Black,
      })}
      href={isClickable ? url : undefined}
      aria-label={isClickable ? `Visit ${title}` : undefined}
    >
      <div
        className={cx(mediaContainerCss, {
          [image169Css]: aspectRatio === '16:9',
          [image32Css]: aspectRatio === '3:2',
          [image11Css]: aspectRatio === '1:1',
        })}
      >
        <div className={mediaElementCss}>{media}</div>
      </div>
      <div className={contentContainerCss}>
        <div className={titleContainerCss}>
          <h3 className={titleCss}>{title}</h3>
          {isClickable && (
            <Icon aria-hidden="true" name="card-stack-arrow-right" className={arrowIconCss} />
          )}
        </div>
        {body && (
          <div
            className={cx(bodyCss, {
              [blackIconCss]: theme === BackgroundColor.Black,
            })}
          >
            {body}
          </div>
        )}
      </div>
    </CardWrapper>
  );
};

CardStackCard.displayName = 'CardStackCard';
